





















import { mapGetters } from 'vuex';
import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import RadioToggle from '@/Shared/RadioToggle.vue';
import CustomerView from './AppellantInformation/CustomerView.vue';
import AppellantView from './AppellantInformation/AppellantView.vue';

export default mixins(LocationBasedMixin).extend({
    components: {
        RadioToggle,
        CustomerView,
        AppellantView
    },
    computed: {
        ...mapGetters('appealModule', [
            'searchError',
            'searchInProgress'
        ])
    },
    data() {
        return {
            i18nPrefix: 'appeals.information'
        };
    }
});
